import React, { useRef, useState,useEffect } from "react";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import { mediaUrl,apiCall } from "../util";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay, faPause } from "@fortawesome/free-solid-svg-icons";
import { quotes, quotes_icon } from "../Image";
import axios from "axios";
import { Link } from "react-router-dom";

const PatientTestimonial = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
   const [data,setData]=useState([])
      const [titleData,setTitleData]=useState(null)

  const handlePlayPause = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };


  useEffect(() => {
    const fetchTestimonialData = async () => {
      try {
        const response = await axios.post(apiCall + "testimonial/getall");
        setData(response.data.filter((item) => item.isView === 1).slice(0, 2));
        const result = await axios.post(apiCall + "testimonialtitle/getall");
        if (result.data[0]) {
          setTitleData(result.data[0]);
        }
      } catch (error) {
        console.error("Error fetching testimonial data:", error);
      }
    };
    fetchTestimonialData();
  }, []);


  return (
    <section className="bg-very-light-gray overflow-hidden">
      <div className="container">
        <div className="row align-items-center justify-content-center mb-6">
          {/* Left Section */}
          <ScrollAnimation
            animateIn="animate__fadeInUp"
            animateOnce={true}
            duration={1.2}
            delay={0.3}
            className="col-xl-5 col-lg-5 md-mb-20px d-flex gap-3"
          >
            <div>
              <img
                src={quotes}
                className="w-80px"
                alt="Quotes"
              />
            </div>
            <div>
              <span className="text-base-color fw-600 -mb-5px text-uppercase d-block fs-12">
                Super Speciality Hospital
              </span>
              <h4 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
                Patients{" "}
                <span className="text-gradient-sg-red-purple">
                  Testimonials
                </span>
              </h4>
            </div>
          </ScrollAnimation>

          {/* Right Section */}
          <ScrollAnimation
            animateIn="animate__fadeIn"
            animateOnce={true}
            duration={1.2}
            delay={0.5}
            className="col-xl-5 col-lg-5 last-paragraph-no-margin md-mb-30px"
          >
            <p
              className="w-90 xl-w-100 md-w-80 sm-w-100 md-mx-auto"

            >
              {titleData?.title
                ? titleData.title
                : "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut dolores ipsum sint alias iste adipisci."}
            </p>
          </ScrollAnimation>

          {/* Button */}
          <ScrollAnimation
            animateIn="animate__fadeInUp"
            animateOnce={true}
            duration={1.2}
            delay={0.6}
            className="col-xl-2 col-lg-2 d-flex justify-content-center justify-content-lg-end"
          >
            <Link to={'/patients-testimonials'}
              className="btn btn-gradient-sg-header d-table d-lg-inline-block lg-mb-15px sg-border-styled fw-600 pe-25px ps-25px"
            >
              View all
              <i className="fa-solid fa-arrow-up-right-from-square"></i>
            </Link>
          </ScrollAnimation>
        </div>

        <div className="row gy-4">
          {data.map((testimonial, index) => (
            <div className="col-12 col-lg-6" key={testimonial.id}>
              {testimonial.description ? (
                // Testimonial without video
                <ScrollAnimation
                  animateIn="animate__fadeInUp"
                  animateOnce={true}
                  duration={1.2}
                  delay={index * 150}
                  className="testimonials_box bg-white box-shadow-large h-350px d-flex flex-column align-items-start justify-content-evenly"
                >
                  <div>
                    <img
                      src={quotes_icon}
                      className="w-30px mb-15px"
                      alt="Quotes Icon"
                    />
                    <p className="mb-15px">{testimonial.description}</p>
                  </div>
                  <div className="bg-white p-10px rounded-pill pe-20px border border-color-base-color d-inline-flex align-items-center gap-2">
                    <img
                      src={`${mediaUrl}/${testimonial.image}`}
                      className="w-50px h-50px rounded-pill"
                      alt={testimonial.name}
                    />
                    <div>
                      <h5 className="fs-20 fw-bold text-base-color m-0 lh-sm">
                        {testimonial.name}
                      </h5>
                      <p className="fs-14 lh-sm m-0">
                        {testimonial.location || "Location not specified"}
                      </p>
                    </div>
                  </div>
                </ScrollAnimation>
              ) : (
                // Testimonial with video background
                <ScrollAnimation
                  animateIn="animate__fadeInUp"
                  animateOnce={true}
                  duration={1.2}
                  delay={0.3}
                  className="testimonials_box video_card "
                  // style={{
                  //   position: "relative",
                  //   overflow: "hidden",
                  // }}
                >
                  <video
                    ref={videoRef}
                    autoPlay
                    loop
                    muted
                    playsInline
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  >
                    <source
                      src={`${mediaUrl}/${testimonial.video}`}
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                  <button
                    onClick={handlePlayPause}
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      zIndex: 2,
                      padding: "10px 20px",
                      background: "rgba(0,0,0,0.5)",
                      color: "white",
                      border: "none",
                      borderRadius: "5px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={isPlaying ? faPause : faPlay}
                      style={{ fontSize: "24px", zIndex: 1 }}
                    />
                  </button>
                  <div
                    className="testimonials_box_content z-3 bg-white p-10px rounded-pill pe-20px border border-color-base-color d-inline-flex align-items-center gap-2"
                    style={{ position: "relative", zIndex: 1 }}
                  >
                    <img
                      src={`${mediaUrl}/${testimonial.image}`}
                      className="w-50px h-50px rounded-pill"
                      alt={testimonial.name}
                    />
                    <div>
                      <h5 className="fs-20 fw-bold text-base-color m-0 lh-sm">
                        {testimonial.name}
                      </h5>
                      <p className="fs-14 lh-sm m-0">
                        {testimonial.location || "Location not specified"}
                      </p>
                    </div>
                  </div>
                  <i
                    className="fa-solid fa-circle-play testimonials_video_play_icon"
                    style={{ position: "relative", zIndex: 1 }}
                  ></i>
                </ScrollAnimation>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PatientTestimonial;